import { render, staticRenderFns } from "./LogoutConfirmModal.vue?vue&type=template&id=2b2464a8&scoped=true"
import script from "./LogoutConfirmModal.vue?vue&type=script&lang=ts"
export * from "./LogoutConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./LogoutConfirmModal.vue?vue&type=style&index=0&id=2b2464a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2464a8",
  null
  
)

export default component.exports